import { useState } from "react";

export default function ContractorsPage({
  counterparties,
  payments,
  addCounterparty,
  canAdd
}) {
  const [name, setName] = useState("");

  const createCounterparty = () => {
    if (!name.trim()) {
      return;
    }

    addCounterparty(name.trim());
    setName("");
  };

  return (
    <div className="contractors-page">
      <h1>Контрагенты</h1>

      {canAdd && (
        <div className="contractor-create">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Название контрагента"
          />

          <button onClick={createCounterparty}>
            Добавить контрагента
          </button>
        </div>
      )}

      <div className="contractor-list">
        {counterparties.length === 0 && (
          <p className="contractor-empty">Нет заполненных контрагентов.</p>
        )}

        {counterparties.map((counterparty) => {
          const count = payments.filter(
            (payment) => payment.contractor === counterparty
          ).length;

          return (
            <div className="contractor-row" key={counterparty}>
              <strong>{counterparty}</strong>
              <span>{count} платежей</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
